import React, { useState, useEffect } from "react";
import SelectDropdown from "../../components/SelectDropdown";
import { RiAdminFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { GetMemberByRole } from "../../store/actions/user-action";
import { DisableMember } from "../../store/actions/user-action";
import toastMessage from "../../toast";
import Table from "../../components/Table/Table";
function ManageMemberPage() {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    input: "",
    memberType: "Admin", // Default value for member type
  });

  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleCloseImageModal = () => {
    setSelectedImage(null);
  };

  const handleChange = (name, value) => {
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Select member details from Redux state
  const { memberDetails } = useSelector((state) => state.memberDetails);

  // useEffect to fetch data based on selected member type
  useEffect(() => {
    if (state.memberType) {
      // Dispatch action to fetch members by role (Admin, Vendor, Driver)
      dispatch(GetMemberByRole(state.memberType.toLowerCase()));
    }
  }, [state.memberType, dispatch]);

  // Function to return data based on selected member type
  const getDataForMemberType = () => {
    return Array.isArray(memberDetails) ? memberDetails : []; // Return data from Redux store
  };

  // Function to handle manage button click
  const handleManage = (item) => {
    let payload = {
      memberId: item._id,
    };
    if (item.role !== "admin") {
      dispatch(DisableMember(payload));
    } else {
      toastMessage("error", "Admin cant be disable");
    }
  };

  return (
    <div>
      <div className="w-2/6 m-4">
        <SelectDropdown
          header={"select role"}
          className="p-2 border border-gray-300 rounded-md bg-white"
          name="memberType"
          icon={<RiAdminFill />}
          value={state.memberType}
          onChange={(e) => handleChange("memberType", e.target.value)}
          options={[
            { value: "Admin", label: "Admin" },
            { value: "Vendor", label: "Vendor" },
            { value: "Driver", label: "Driver" },
          ]}
        />
      </div>
      <div className="p-[25px] rounded-md border-[solid] border bg-white">
        <div className="overflow-x-auto w-full">
          <Table
            className="overflow-x-auto w-full"
            header={
              state?.memberType === "Admin"
                ? ["Admin name", "mobile no", "action"]
                : state?.memberType === "Vendor"
                ? [
                    "Vendor name",
                    "mobile no",
                    "shop name",
                    "address",
                    "location",
                    "action",
                  ]
                : [
                    "driver name",
                    "mobile no",
                    "driver_wallet",
                    "address",
                    "location",
                    "vehical no",
                    "police verification",
                    "action",
                  ]
            }
          >
            {getDataForMemberType()?.map((item, index) => (
              <tr
                key={index}
                className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
              >
                <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[12rem] ">
                  <div className="flex items-center">
                  <img
                        src={
                          item?.avatar || "https://th.bing.com/th/id/OIP.1mSyfMp-r01kxBYitbubbAHaHa?w=198&h=198&c=7&r=0&o=5&dpr=1.3&pid=1.7"
                        }
                        alt={`police verification`}
                        onClick={() => handleImageClick(item?.avatar)}
                        className="w-[40px] h-[40px] object-cover rounded-full border-2 border-[rgb(144 144 144)] shadow-md cursor-pointer mr-2 p-1 "
                      />
                    {item.name}
                  </div>
                </td>
                <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[9rem]">
                  {item.phoneNumber}
                </td>
                {state?.memberType == "Vendor" && (
                  <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[13rem]">
                    {item?.shop_name}
                  </td>
                )}
 {state?.memberType == "Driver" && (
                  <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[13rem]">
                    {item?.driver_wallet}
                  </td>
                )}   
                {(state?.memberType == "Vendor" ||
                  state?.memberType == "Driver") && (
                  <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[13rem]">
                    {item.address}
                  </td>
                )}

                {(state?.memberType == "Vendor" ||
                  state?.memberType == "Driver") && (
                  <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[13rem]">
                    Lat : {item?.location?.lat} <br />
                    Lng : {item?.location?.lng}
                  </td>
                )}
                {state?.memberType == "Driver" && (
                  <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[9rem]">
                    {item?.vehicle_no}
                  </td>
                )}
                {state?.memberType == "Driver" && (
                  <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[15rem] flex justify-center">
                    {/* {item?.policeVerification} */}
                    <img
                      src={item?.policeVerification}
                      alt={`police verification`}
                      onClick={() => handleImageClick(item?.policeVerification)}
                      className="w-[70px] h-[70px] object-cover rounded-[10px] shadow-md cursor-pointer "
                    />
                  </td>
                )}
                <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[9rem] ">
                  <button
                    className={`${
                      item?.disable
                        ? "text-white border border-green-600 bg-green-600 hover:bg-green-700"
                        : "text-white border border-red-600 bg-red-600 hover:bg-red-700"
                    } font-medium rounded-lg text-sm px-3 py-1 text-center`}
                    onClick={() => handleManage(item)}
                  >
                    {item?.disable ? "Enable" : "Disable"}
                  </button>
                </td>
              </tr>
            ))}
          </Table>
        </div>
      </div>
      {selectedImage && (
        <div className="fixed inset-0 z-[150] flex items-center justify-center bg-gray-500 bg-opacity-75">
          <div className="relative w-fit h-full">
            <div
              className="mx-auto flex w-[35px] h-[35px] absolute right-4 top-4 flex-shrink-0 items-center justify-center rounded-full bg-red-100 cursor-pointer"
              onClick={handleCloseImageModal}
            >
              <svg
                className="h-6 w-6 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 6l12 12M6 18L18 6"
                />
              </svg>
            </div>
            <img
              src={selectedImage}
              alt="Selected"
              className="max-w-[100%] max-h-[100%] object-contain cursor-pointer"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ManageMemberPage;
